/* ═══════════════════════════════════════════
   PARTICLE BACKGROUND
═══════════════════════════════════════════ */
(function(){
  const canvas = document.getElementById('bgCanvas');
  const ctx = canvas.getContext('2d');
  let W, H, particles = [], connections = [];
  const COLORS = ['rgba(0,245,255,', 'rgba(155,93,229,', 'rgba(230,57,70,'];
  const DPR = Math.min(window.devicePixelRatio || 1, 1.5);
  const LINK_DIST = 110, LINK_DIST_SQ = LINK_DIST * LINK_DIST;

  function resize(){
    // Canvas is position:fixed — size bitmap to the VIEWPORT only, not page scrollHeight
    W = window.innerWidth;
    H = window.innerHeight;
    canvas.width = W * DPR;
    canvas.height = H * DPR;
    canvas.style.width = W + 'px';
    canvas.style.height = H + 'px';
    ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
  }

  function createParticle(){
    return {
      x: Math.random() * W,
      y: Math.random() * H,
      vx: (Math.random() - .5) * .4,
      vy: (Math.random() - .5) * .4,
      r: Math.random() * 1.5 + .5,
      color: COLORS[Math.floor(Math.random() * COLORS.length)],
      alpha: Math.random() * .5 + .2,
      pulse: Math.random() * Math.PI * 2,
      pulseSpeed: .02 + Math.random() * .02
    };
  }

  function init(){
    resize();
    const count = Math.min(70, Math.floor(W * H / 18000));
    particles = Array.from({length: count}, createParticle);
  }

  function draw(){
    ctx.clearRect(0, 0, W, H);

    // Draw connections — squared distance (no sqrt), capped particle count
    for(let i = 0; i < particles.length; i++){
      for(let j = i + 1; j < particles.length; j++){
        const dx = particles[i].x - particles[j].x;
        const dy = particles[i].y - particles[j].y;
        const distSq = dx*dx + dy*dy;
        if(distSq < LINK_DIST_SQ){
          ctx.beginPath();
          ctx.moveTo(particles[i].x, particles[i].y);
          ctx.lineTo(particles[j].x, particles[j].y);
          ctx.strokeStyle = `rgba(0,245,255,${(1 - Math.sqrt(distSq)/LINK_DIST) * 0.06})`;
          ctx.lineWidth = .5;
          ctx.stroke();
        }
      }
    }

    // Draw particles
    particles.forEach(p => {
      p.pulse += p.pulseSpeed;
      const a = p.alpha * (.7 + .3 * Math.sin(p.pulse));
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
      ctx.fillStyle = p.color + a + ')';
      ctx.fill();

      // Glow
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.r * 3, 0, Math.PI * 2);
      ctx.fillStyle = p.color + (a * .15) + ')';
      ctx.fill();

      p.x += p.vx;
      p.y += p.vy;
      if(p.x < 0) p.x = W;
      if(p.x > W) p.x = 0;
      if(p.y < 0) p.y = H;
      if(p.y > H) p.y = 0;
    });

    requestAnimationFrame(draw);
  }

  // Pause everything when the tab is hidden — saves battery/CPU
  let running = false;
  function start(){ if(!running){ running = true; requestAnimationFrame(draw); } }
  function stop(){ running = false; }
  document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());

  let resizeTimer;
  window.addEventListener('resize', ()=>{
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(()=>{ resize(); init(); }, 150); // re-seed particles for new size
  });
  init();
  start();
})();

/* ═══════════════════════════════════════════
   SCROLL REVEAL
═══════════════════════════════════════════ */
(function(){
  const els = document.querySelectorAll('.sr');
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if(e.isIntersecting) { e.target.classList.add('visible'); }
    });
  }, { threshold: 0.15 });
  els.forEach(el => io.observe(el));
})();

/* ═══════════════════════════════════════════
   ANIMATED COUNTERS
═══════════════════════════════════════════ */
(function(){
  const nums = document.querySelectorAll('.stat-num[data-target]');
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if(!e.isIntersecting) return;
      const el = e.target;
      const target = parseInt(el.dataset.target);
      const suffix = el.dataset.suffix || '';
      const dur = 2000;
      const start = performance.now();
      function tick(now){
        const t = Math.min((now - start) / dur, 1);
        const ease = 1 - Math.pow(1 - t, 3);
        const val = Math.round(ease * target);
        el.textContent = val + suffix;
        if(t < 1) requestAnimationFrame(tick);
        else el.textContent = target + suffix;
      }
      requestAnimationFrame(tick);
      io.unobserve(el);
    });
  }, { threshold: 0.5 });
  nums.forEach(n => io.observe(n));
})();

/* ═══════════════════════════════════════════
   SCROLL SCRUB — PRECISE PER-PIXEL CONTROL
═══════════════════════════════════════════ */
(function(){
  const outer    = document.getElementById('scrubOuter');
  const steps    = Array.from({length:6}, (_,i) => document.getElementById('st'+i));
  const panels   = Array.from({length:6}, (_,i) => document.getElementById('sp'+i));
  const dots     = Array.from(document.querySelectorAll('.scrub-dot'));
  const progress = document.getElementById('scrubProgress');
  const N = 6;

  function update(){
    const rect = outer.getBoundingClientRect();
    const total = outer.offsetHeight - window.innerHeight;
    if(total <= 0) return;

    // Raw progress 0→1 across entire scrub section
    const raw = Math.max(0, Math.min(1, -rect.top / total));

    // Which step we're on (0-5), with fractional position within step
    const exactStep = raw * N;
    const stepIdx = Math.min(N - 1, Math.floor(exactStep));

    // Activate text panels
    steps.forEach((s, i) => {
      if(i === stepIdx) s.classList.add('active');
      else s.classList.remove('active');
    });

    // Activate visual panels
    panels.forEach((p, i) => {
      if(i === stepIdx) p.classList.add('active');
      else p.classList.remove('active');
    });

    // Dots
    dots.forEach((d, i) => {
      if(i === stepIdx) d.classList.add('on');
      else d.classList.remove('on');
    });

    // Progress bar
    if(progress) progress.style.width = (raw * 100) + '%';
  }

  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  update();
})();